export default function DepartmentManage(){
    return (
        <div>
            部门管理
        </div>
    )
}